import React, { useEffect, useRef, useState } from "react";
import ViewTable from "../../../Components/Common/ViewTable";
import { api, get } from "../../../utils/api";
import Cards from "../../../Components/Common/Cards";
import FilterModal from "../../../Components/Common/FilterModal";
import ActionButtons from "../../../Components/Common/ActionButtons";
import DeleteDialog from "../../../Components/Masters/DeleteDialog";
import MessagePopup from "../../../Components/Masters/MessagePopup";
import AddData from "./AddData";
import { Box } from "@mui/material";
import ViewData from "./ViewData";
import BulkUploadModal from "../../../Components/Common/BulkUploadModal";
import { formatNumber } from "../../../utils/formatNumber";
import { formatNumberCommaSeparated } from "../../../utils/common";
import BulkUpload from "./BulkUpload";
import { useUser } from "../../../context/AuthContext";
import DeleteAlertDialog from "../../../Components/Masters/DeleteAlertDialog";

const WasteGenerated = () => {
  const { user } = useUser();
  const [cardData, setCardData] = useState(null);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [tableData, setTableData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [filters, setFilters] = useState({
    facility: [],
    wasteType: [],
    wasteManagementMethod: [],
  });
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const [isLoading, setIsLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const [page, setPage] = useState(1);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [deletedItemId, setDeletedItemId] = useState("");
  const [selectedWasteMethod, setSelectedWasteMethod] = useState("");
  const [matchData, setMatchData] = useState([]);
  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [excelData, setExcelData] = useState(null);
  const [bulkUploadTable, setBulkUploadTable] = useState(false);
  const [formDataBulkUpload, setFormDataBulkUpload] = useState({});
  const [jsonBulkUpload, setJsonBulkUpload] = useState([]);

  const uploadErrorClose = () => {
    setBulkUploadTable(true);
  };

  const fetchExcelData = async () => {
    await get("/scope3/wasteGeneratedInOperations/generateWasteGeneratedExcel")
      .then((res) => {
        let data = res?.data?.data;
        
        // Add reference rows showing valid options
        const commonMethodsList = ["Reuse", "Recycling", "Landfilling", "Incineration", "Composting"];
        const maxRows = Math.max(
          wasteCategoryOptions.length,
          wasteTypeOptions.length,
          commonMethodsList.length,
          data.length
        );
        
        // Create reference rows with all valid options
        let optionsRows = [];
        for (let i = 0; i < maxRows; i++) {
          optionsRows.push({
            "Month (in 01/25 or Jan-25)": "",
            "Vendor Name": data[i]?.vendorLegalName || "",
            "Waste Category": wasteCategoryOptions[i] || "",
            "Waste Type": wasteTypeOptions[i] || "",
            "Waste Management Method": commonMethodsList[i] || "",
            "Quantity of Waste Generated (Tonnes)": "",
            "Quantity of Waste Managed": "",
          });
        }
        
        // Add empty row separator
        optionsRows.push({
          "Month (in 01/25 or Jan-25)": "",
          "Vendor Name": "",
          "Waste Category": "",
          "Waste Type": "",
          "Waste Management Method": "",
          "Quantity of Waste Generated (Tonnes)": "",
          "Quantity of Waste Managed": "",
        });
        
       
        
        // Combine options rows with data rows
        const finalData = [...optionsRows];
        console.log("Excel data with options:", finalData);
        setExcelData(finalData);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchExcelData();
  }, []);

  useEffect(() => {
    fetchCardData(selectedWasteMethod || filters.wasteManagementMethod[0]);
  }, [selectedWasteMethod]);

  const fetchCardData = async (wasteMethod) => {
    try {
      let response = await get(
        `${api}/scope3/wasteGeneratedInOperations/cardData`,
        { params: { wasteMethod } }
      );
      setCardData(response.data.data);
    } catch (error) {
      console.error("Error fetching card data:", error);
    }
  };
  const commonMethods = [
    "Reuse",
    "Recycling",
    "Landfilling",
    "Incineration",
    "Composting",
  ];
  const wasteManagementMapping = {
    Aggregates: ["Recycling", "Landfilling"],
    "Average construction": ["Recycling", "Incineration"],
    Asbestos: ["Landfilling"],
    Asphalt: ["Recycling", "Landfilling"],
    Bricks: ["Recycling", "Landfilling"],
    Concrete: ["Recycling", "Landfilling"],
    Insulation: ["Recycling", "Landfilling"],
    Metals: ["Recycling", "Landfilling"],
    Soils: ["Recycling", "Landfilling"],
    "Mineral oil": ["Recycling", "Incineration"],
    Plasterboard: ["Recycling", "Landfilling"],
    Tyres: ["Recycling"],
    Wood: ["Recycling", "Incineration", "Landfilling"],
    Books: ["Recycling", "Incineration", "Landfilling"],
    Glass: ["Recycling", "Incineration", "Landfilling"],
    Clothing: ["Recycling", "Incineration", "Landfilling"],
    "Organic mixed food and garden waste": [
      "Incineration",
      "Landfilling",
      "Composting",
    ],
    "Electrical item": ["Recycling", "Incineration", "Landfilling"],
    Plastic: ["Recycling", "Incineration", "Landfilling"],
    "Paper and board": ["Recycling", "Incineration", "Landfilling"],
  };

  const wasteTypeOptions = [
    "Aggregates",
    "Asbestos",
    "Asphalt",
    "Average construction",
    "Books",
    "Bricks",
    "Clothing",
    "Concrete",
    "Electrical item",
    "Glass",
    "Insulation",
    "Metals",
    "Mineral oil",
    "Organic mixed food and garden waste",
    "Paper and board",
    "Plastic",
    "Plasterboard",
    "Soils",
    "Tyres",
    "Wood",
  ];
  let bannerData = [  
    {
      title: "Total Quantity of Waste Generated",
      description: formatNumber(cardData?.totalWasteGenerated || 0),
      unit: "Tonnes",
    },
    {
      title: "Top Waste Types",
      description: cardData?.topWasteTypes.map((el) => el._id),
    },
    {
      title: "Total Quantity of Waste Managed",
      description:
        formatNumberCommaSeparated(
          formatNumber(
            cardData?.wasteManagedByMethod?.totalManagedQuantity || 0
          )
        ) + " Tonnes",
      filter: "option",
      key: "wasteManagedByMethod",
      filterValues: filters?.wasteManagementMethod,
      defaultValue: selectedWasteMethod,
    },
  ];

  const wasteCategoryOptions = [
    "Hazardous Waste",
    "Non-Hazardous Waste",
    "Construction & Demolition Waste",
    "Wastewater",
  ];

  const inputData = [
    {
      fieldName: "consumptionPeriod",
      title: "Waste Management Month",
      required: true,
      type: "date",
      width: "2rem",
    },
    {
      fieldName: "wasteCategory",
      title: "Waste Category",
      type: "select",
      options: wasteCategoryOptions,
      width: "5rem",
    },
    {
      fieldName: "wasteType",
      title: "Waste Type",
      type: "select",
        options: wasteTypeOptions,
    },

    {
      fieldName: "quantityOfWasteGenerated",
      title: "Quantity of Waste Generated",
      placeholder: "Enter Quantity",
      type: "number",
      nested: true,
      // options: ["Kg", "Tons"],
    },
    {
      fieldName: "wasteManagementMethod",
      title: "Waste Management Method",
      placeholder: "Select Waste Management Method",
      type: "select",
      options:commonMethods,
    },
    {
      fieldName: "vendorName",
      title: "Vendor Name of Waste Management",
      placeholder: "Select Vendor",
      type: "select",
      url: `${api}/master/wasteManagement`,
      field: "vendorLegalName",
      // Assuming you have a list of vendors from some API
    },
    {
      fieldName: "quantityOfWasteManaged",
      title: "Quantity of Waste Managed",
      placeholder: "Enter Quantity",
      type: "number",
      nested: true,
      // options: ["Kg", "Tons"],
    },
    {
      fieldName: "editRemarkReason",
      title: "Edit Remark Reason",
      placeholder: "Additional edit remarks",
      type: "text",
      condition: true,
    },
    {
      fieldName: "documents",
      title: "Upload Documents (optional)",
      placeholder: "Upload Documents",
      type: "file", // assuming you allow uploading multiple files
    },
  ];

  const headers = [
    { key: "createdAt", label: "Date", sortable: true, width: "15%" },
    {
      label: "Waste Management Month",
      key: "consumptionPeriod",
      sortable: true,
      width: "20%",
    },
    { key: "wasteType", label: "Waste Type", sortable: true, width: "15%" },
    {
      key: "quantityOfWasteGenerated",
      label: "Quantity of Waste Generated",
      sortable: true,
      width: "15%",
    },
    {
      key: "wasteManagementMethod",
      label: "Waste Management Method",
      sortable: true,
      width: "20%",
    },
    {
      key: "quantityOfWasteManaged",
      label: "Quantity of Waste Managed",
      sortable: true,
      width: "20%",
    },
  ];

  const filterData = [
    { title: "Date", type: "date", key: "createdAt", value: "" },
    {
      key: "consumptionMonth",
      type: "month",
      title: "Waste Mangement Month",
      sortable: true,
    },
    {
      title: "Waste Type",
      type: "option",
      key: "wasteType",
      value: filters?.wasteType,
    },
    {
      title: "Quantity of Waste Generated",
      type: "limit",
      key: "quantity",
      value: [],
      min: "minQty",
      max: "maxQty",
    },
    {
      title: "Waste Management Method",
      type: "option",
      key: "wasteManagementMethod",
      value: filters?.wasteManagementMethod,
    },
    {
      title: "Quantity of Waste Managed",
      type: "limit",
      key: "quantityManaged",
      value: [],
      min: "minQtyManaged",
      max: "maxQtyManaged",
    },
  ];

  const updatePage = () => {
    if (page > 1 && tableData?.length === 1) {
      setPage(page - 1);
    }
    setIsLoading(true);
    fetchData();
  };

  const fetchData = async () => {
    let filter = { ...filterObj };
    fetchCardData(selectedWasteMethod);
    console.log(filter, "selectedfilter");
    if (filter.quantity) {
      filter.minQty = parseInt(filterObj.quantity.min);
      filter.maxQty = parseInt(filterObj.quantity.max);
      delete filter.quantity;
    }
    if (filter.quantityManaged) {
      filter.minQtyManaged = parseInt(filterObj.quantityManaged.min);
      filter.maxQtyManaged = parseInt(filterObj.quantityManaged.max);
      delete filter.quantity;
    }
    if (filter.createdAt) {
      filter.startDate = filter?.createdAt?.start || "";
      filter.endDate = filter?.createdAt?.end || "";
      delete filter?.createdAt;
    }
    if (filter.consumptionMonth) {
      filter.startMonth = filter?.consumptionMonth?.start || "";
      filter.endMonth = filter?.consumptionMonth?.end || "";
      delete filter?.consumptionMonth;
    }

    console.log("filter", filter);
    const queryParams = new URLSearchParams({
      ...filter,
      page: currentPage,
      limit: rowsPerPage,
      sortField: sortConfig.key,
      sortOrder: sortConfig.direction,
    }).toString();
    try {
      const res = await get(
        `/scope3/wasteGeneratedInOperations/get?${queryParams}`
      );
      setTotalPages(res.data.totalPages);
      setTableData(res.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [sortConfig, currentPage, page, filterObj]);

  const fetchFilters = async () => {
    try {
      const { data } = await get(`/scope3/wasteGeneratedInOperations/filter`);
      const { wasteType, wasteManagementMethod } = data?.data || {};
      console.log("first", wasteType, wasteManagementMethod);
      setFilters({
        wasteType: wasteType || [],
        wasteManagementMethod: wasteManagementMethod || [],
      });

      setSelectedWasteMethod(selectedWasteMethod || wasteManagementMethod[0]);
    } catch (err) {
      console.error("Fetch Filters Error:", err);
    }
  };

  useEffect(() => {
    fetchFilters();
  }, []);

  const openModal = (type, dataForEdit) => {
    if (type === "add") {
      setIsModalOpen(true);
    } else if (type === "edit") {
      setEditModal(true);
      console.log("data", dataForEdit);
      setEditData(dataForEdit);
      setViewModal(false);
    }
  };

  const handleEdit = () => {
    // data.createdAt = data?.createdAt.split("T")[0];
    // data.dateOfTravel = data?.dateOfTravel.split("T")[0];
    setEditData(editData);
    setViewModal(false);
    setEditModal(true);
  };

  const openViewModal = (data) => {
    setEditData(data);
    setViewModal(true);
  };

  const handleSort = (key, direction) => {
    setSortConfig({ key, direction });
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    console.log("page change", newPage);
  };

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
    setCurrentPage(1);
  };

  console.log("editdata", editData);

  const closeModal = (type) => {
    if (type === "add") {
      setIsModalOpen(false);
    } else if (type === "edit") {
      setEditModal(false);
      setEditData({});
    }
  };

  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height

      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 3.2);
    }
  }, [tableData]);

  const handleSelectChange = (key, value, filterType) => {
    console.log(key, value, filterType);
    setSelectedWasteMethod(value);
  };

  const handleDeleteOpen = (itemId) => {
    setDeletedItemId(itemId);
    setDeleteDialog(true);
  };

  const handleCloseBulkUpload = () => {
    setBulkUploadModal(false);
    fetchData();
  };

  return (
    <Box>
      <Cards
        width="7rem"
        data={bannerData}
        title={"Waste Generated in Operations"}
        onFilterChange={handleSelectChange}
      />
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      <ActionButtons
        onFilterClick={() => setIsFilterModalOpen(true)}
        onAddClick={() => openModal("add")}
        filterObj={filterObj}
        onUploadClick={() => setBulkUploadModal(true)}
      />
      <ViewTable
        tableContainerRef={tableContainerRef}
        headers={headers}
        data={tableData ?? []}
        onSort={handleSort}
        sortConfig={sortConfig}
        totalPages={totalPages}
        page={currentPage}
        isShortContent={isShortContent}
        editIcon={user?.companyAdmin ? "disable" : "enable"}
        field="unit"
        title={"Waste Generated in Operations"}
        count={page}
        onPageChange={handlePageChange}
        onView={(row) => {
          openViewModal(row);
        }}
        onEdit={(row) => openModal("edit", row)}
        onDelete={(row) => handleDeleteOpen(row._id)}
      />
      <AddData
        handleClose={() => closeModal(editModal ? "edit" : "add")}
        id={editData ? editData._id : ""}
        title="Waste Generated in Operations"
        addData={editModal ? editModal : isModalOpen}
        addUrl={`${api}/scope3/wasteGeneratedInOperations/add`}
        updateUrl={`${api}/scope3/wasteGeneratedInOperations/update`}
        {...{
          fetchData,
          setsnackOpen,
          inputData,
          element: editData,
          setAddData: setEditModal,
        }}
      />
      <ViewData
        id={editData ? editData._id : ""}
        element={editData}
        title={"Waste Generated in Operation Details"}
        viewData={viewModal}
        setData={setEditData}
        setViewData={setViewModal}
        inputData={inputData}
        handleEdit={handleEdit}
        companyAdmin={user?.companyAdmin}
      />
      {deleteDialog && (
        <DeleteAlertDialog
          fetchData={updatePage}
          {...{
            deleteDialog,
            setDeleteDialog,
            id: deletedItemId,
            url: `${api}/scope3/wasteGeneratedInOperations/delete`,
            setsnackOpen,
          }}
        />
      )}
      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        filters={filterData}
        onFilterChange={handleFilterChange}
        title="Filter"
      />
      {bulkUploadModal && (
        <BulkUploadModal
          onCloseBulkUpload={handleCloseBulkUpload}
          isBulkUploadModal={bulkUploadModal}
          excelData={excelData}
          setMatchData={setMatchData}
          formDataBulkUpload={formDataBulkUpload}
          setFormDataBulkUpload={setFormDataBulkUpload}
          setJsonBulkUpload={setJsonBulkUpload}
          matchedKey="statusList"
          errorClose={uploadErrorClose}
          setBulkUploadModal={setBulkUploadModal}
          fileName={"Waste Generated"}
          setsnackOpen={setsnackOpen}
          url={"/scope3/wasteGeneratedInOperations/bulkupload"}
        />
      )}
      {bulkUploadTable && (
        <BulkUpload
          matchData={matchData}
          inputData={inputData.slice(0, -3)}
          setMatchData={setMatchData}
          onClose={() => setBulkUploadTable(false)}
          bulkUploadTable={bulkUploadTable}
          {...{ formDataBulkUpload, setFormDataBulkUpload }}
          jsonBulkUpload={jsonBulkUpload}
          bulkUploadUrl={`${api}/scope3/wasteGeneratedInOperations/jsonupload`}
          setsnackOpen={setsnackOpen}
          title1="Vendor Name"
          title2="Waste Type"
          title3="Waste Management Method"
          keyValue1="vendor"
          keyValue2="wasteType"
          keyValue3="wasteManagementMethod"
          matched1={"vendorMatched"}
          matched2={"wasteTypeMatched"}
          matched3={"wasteManagementMethodMatched"}
          options1={["categoryData"]}
          options2={wasteTypeOptions}
          options3={wasteManagementMapping}
          onConfirm={() => {
            setBulkUploadTable(false);
            fetchData();
          }}
        />
      )}
    </Box>
  );
};

export default WasteGenerated;
